import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/data';

export default function LatestUpdates() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">实时追踪最新上线的精彩内容</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {latestUpdates.map((item) => (
            <Link
              key={item.id}
              to={`/category/${item.category === '电影' ? 'dianying' : item.category === '电视剧' ? 'dianshiju' : item.category === '综艺' ? 'zongyi' : item.category === '动漫' ? 'dongman' : item.category === '纪录片' ? 'jilupian' : 'yinyue'}`}
              className="flex items-center gap-3 p-3 rounded-lg bg-white hover:bg-background-100 transition-colors duration-200 cursor-pointer group"
            >
              <div className="w-20 h-14 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  loading="lazy"
                />
              </div>
              <div className="min-w-0">
                <h4 className="text-sm font-medium text-foreground-800 truncate group-hover:text-primary-600 transition-colors duration-200">
                  {item.title}
                </h4>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-xs px-1.5 py-0.5 rounded bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.category}
                  </span>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}